import { defineStore } from 'pinia'
import { getTeamForGroupAPI } from '@/services/teams-service'
import { useStatesStore } from './states-store'

export const useTeamsStore = defineStore('teams-store', {
  state: () => ({
    error: {},
    loading: false,
    createOrUpdateNoteLoading: false,
    teams: {}
  }),
  actions: {
    clear() {
      this.error = {}
      this.loading = {}
      this.teams = {}
    },
    async getTeamForGroupAction({ groupName }) {
      this.loading = true
      const statesStore = useStatesStore()
      try {
        const res = await getTeamForGroupAPI({ groupName })
        if (res) {
          this.teams = res
          const teamForGroup = res.teams[0]
          statesStore.setTeamForSelectedGroup(teamForGroup)
        }
        this.loading = false
      } catch (error) {
        statesStore.setTeamForSelectedGroup(null)
        this.error = error
        throw error
      } finally {
        this.loading = false
      }
    }
  }
})
